import { ApplicationRef, ComponentRef, inject, Injectable, Injector } from '@angular/core';
import { ComponentPortal, DomPortalOutlet } from '@angular/cdk/portal';
import { WaitingDialog } from './waitingDialog.component';

@Injectable({
    providedIn: 'root'
})
export class WaitingDialogService {
 private portalOutlet: DomPortalOutlet;
  private componentRef: ComponentRef<WaitingDialog> | null = null;

  private appRef: ApplicationRef = inject(ApplicationRef);
    private injector: Injector = inject(Injector);
   constructor(  ) {
    this.portalOutlet = new DomPortalOutlet(
      document.body,
      this.appRef,
      this.injector
    );
  }

    show(message:string): void {
    if (!this.componentRef) {
      const portal = new ComponentPortal(WaitingDialog, null, this.injector);
      this.componentRef = this.portalOutlet.attach(portal);
        this.componentRef.instance.message = message;
    }
  }

  hide(): void {
    if (this.componentRef) {
     // this.portalOutlet.detach();
      this.componentRef.destroy();
      this.componentRef = null;
    }
  }
  
}